import React, { useState } from "react";
import "./Navbar.css";
import production from "../../images/production.png";
import portal from "../../images/portal.png";
import setting from "../../images/setting.png";
import tes from "../../images/test-manager.png"
import { Link } from "react-router-dom";
const Navbar = ({isActive}) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className={isActive ? "nav navactive" : "nav"}>
        <ul>
          <li>
            {" "}
            <Link
              to="/trs"
              className={activeTab === 0 ? "active" : ""}
              onClick={() => setActiveTab(0)}
            >
              <img src={production} alt="" /> Production Jigs
            </Link>
          </li>
          <li>
            {" "}
            <Link
              to="/portalCTQ"
              className={activeTab === 1 ? "active" : ""}
              onClick={() => setActiveTab(1)}
            >
              <img src={portal} alt="" /> Portals
            </Link>{" "}
          </li>
          <li>
            {" "}
            <Link
              to="/Configration"
              className={activeTab === 2 ? "active" : ""}
              onClick={() => setActiveTab(2)}
            >
              <img src={setting} alt="" />
              Stock Manager
            </Link>{" "}
          </li>
          <li>
            {" "}
            <Link
              to="/account"
              className={activeTab === 2 ? "active" : ""}
              onClick={() => setActiveTab(2)}
            >
              <img src={tes} alt="" />
              Acounts
            </Link>{" "}
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navbar;
